import { componentQrl, inlinedQrl, createElement } from "@builder.io/qwik";
import { isEditing } from "../../../functions/is-editing.qwik.mjs";
const FormInputComponent = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  return /* @__PURE__ */ createElement("input", {
    ...props.attributes,
    key: isEditing() && props.defaultValue ? props.defaultValue : "default-key",
    placeholder: props.placeholder,
    type: props.type,
    name: props.name,
    value: props.value,
    defaultValue: props.defaultValue,
    required: props.required
  });
}, "FormInputComponent_component_AUUjdN0ueMs"));
export {
  FormInputComponent,
  FormInputComponent as default
};
